import { getStoryblokApi, StoryblokComponent } from '@storyblok/react';
import Head from 'next/head';

import { Section } from '@/components/Layout';
import Page from '@/components/Pages/Page';
import getStoryContent from '@/server/storyblok';

const DynamicCMSPage = ({ story }): JSX.Element => (
  <Page withFooter withHeader>
    <Head>
      <title>{story ? story.name : 'Title'}</title>
    </Head>
    <Section>
      <StoryblokComponent blok={story.content} />
    </Section>
  </Page>
);

export const getStaticProps = async ({ params }) =>
  getStoryContent({
    slug: params.slug.join('/'),
  });

export async function getStaticPaths() {
  const storyblokApi = getStoryblokApi();
  const { data } = await storyblokApi.get('cdn/links/');
  const paths = [];

  Object.keys(data.links).forEach((linkKey) => {
    if (data.links[linkKey].slug === 'home') {
      return;
    }

    const { slug } = data.links[linkKey];
    const splittedSlug = slug.split('/');
    paths.push({ params: { slug: splittedSlug } });
  });

  return {
    fallback: 'blocking',
    paths,
  };
}

export default DynamicCMSPage;
